import React from 'react';

const NotFoundPage = () => {
  return (
    <div>
      <h1>404 - Página não encontrada</h1>
      <p>A página que você está procurando não existe.</p>
    </div>
  );
};

export default NotFoundPage;
